export const TAG = "[CallLogs]";
export const MODULE_TITLE = "Call Logs";
export const SLICE = "callLogsSlice";
export const searchColumns = [
  "call_direction",
  "solution",
  "device",
  "received_time",
  "sr_number",
  "id",
  "lead",
  "notes",
  "customer_number",
  "customer_status",
  "agent && agent_number",
  "call_journey",
  "agent_status",
  "queue",
  "campaign_id",
  "call_duration_formatted",
  "action",
  "dtmf_extensions",
  "call_recording && call_duration_formatted",
  "call_uuid",
  "voicemail_url",
  "disposition",
  "sub_disposition",
  "rule",
  "sms_text",
  "sms_type",
  "sr_number",
];

export const ANALYTICS = {
  ADVANCE_FILTERS_CLICKED: "Advance Filters",
  SEARCH_USAGE: "Search",
  PAGINATION: "Paginated",
  AUDIO_PLAYED: "Call Reording Play",
  VOICEMAIL_PLAYED: "Voice Mail Play",
  PAGE_VIEWED: "Call Logs Page View",
};
